import { loadStripe } from '@stripe/stripe-js';
import axiosInstance from '../Api/axiosInstance';

let stripePromise;

/** Loads Stripe.js using STRIPE_PUBLISHABLE_KEY from the backend. */
const getStripePromise = () => {
	if (!stripePromise) {
		stripePromise = axiosInstance.get('/payment/config').then((res) => {
			const key = res.data?.publishableKey;
			if (!key) {
				throw new Error('Stripe publishable key is not configured on the server.');
			}
			return loadStripe(key);
		});
	}
	return stripePromise;
};

export default getStripePromise;
